var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 5.00008V7.01675C18.3334 8.33341 17.5 9.16675 16.1834 9.16675H13.3334V3.34175C13.3334 2.41675 14.0917 1.66675 15.0167 1.66675C15.925 1.67508 16.7584 2.04175 17.3584 2.64175C17.9584 3.25008 18.3334 4.08341 18.3334 5.00008Z",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 5.83341V17.5001C1.66663 18.1917 2.44996 18.5834 2.99996 18.1668L4.42496 17.1001C4.75829 16.8501 5.22496 16.8834 5.52496 17.1834L6.90829 18.5751C7.23329 18.9001 7.76663 18.9001 8.09163 18.5751L9.49163 17.1751C9.78329 16.8834 10.25 16.8501 10.575 17.1001L12 18.1668C12.55 18.5751 13.3333 18.1834 13.3333 17.5001V3.33341C13.3333 2.41675 14.0833 1.66675 15 1.66675H5.83329H4.99996C2.49996 1.66675 1.66663 3.15841 1.66663 5.00008V5.83341Z",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8416H10",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5083H10",
    stroke: "#51525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99634 10.8333H5.00382",
    stroke: "#51525C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99634 7.5H5.00382",
    stroke: "#51525C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptItem);
export default __webpack_public_path__ + "static/media/receipt-item.06fcfef52e0bbeb13aae1eed3aa40eb3.svg";
export { ForwardRef as ReactComponent };